import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { parseToProjectSpecialTimeDto, PROJECT_SPECIAL_TIME_TYPES, ProjectSpecialTime, ProjectSpecialTimeDtoWithoutNumber, ProjectSpecialTimeWithoutId } from "../types/project-special-time.type";

const BASE_URL: string = "api/projects";
const OPENING_TIMES_URL_SEGMENT: string = "special-opening-times";
const CLOSING_TIMES_URL_SEGMENT: string = "special-closing-times";
const MERGED_TIMES_URL_SEGMENT: string = "special-merged-times";

function buildUrlBase (projectNumber: string, timeSegment: string): string {
  return `${ BASE_URL }/${ projectNumber }/${ timeSegment }`;
}


@Injectable({
  providedIn: "root"
})
export class ProjectSpecialTimeService {
  private readonly _httpClient: HttpClient = inject(HttpClient);


  public addHolidays (projectNumber: string): Observable<HttpResponse<void>> {
    const params: HttpParams = new HttpParams().set("import", "holidays");

    return this._httpClient.put<undefined>(`api/projects/${ projectNumber }/special-closing-times`, {}, { params, observe: "response" });
  }

  // eslint-disable-next-line @tseslint/prefer-readonly-parameter-types, @tseslint/no-unused-vars
  public update (projectNumber: string, oldSpecialTime: ProjectSpecialTime, newSpecialTime: ProjectSpecialTime): Observable<HttpResponse<void>> {
    const parsedSpecialTime: ProjectSpecialTimeDtoWithoutNumber = parseToProjectSpecialTimeDto(newSpecialTime);

    return this._httpClient.put<undefined>(`${ buildUrlBase(projectNumber, MERGED_TIMES_URL_SEGMENT) }/${ newSpecialTime.id }`, parsedSpecialTime, { observe: "response" });
  }

  public delete (projectNumber: string, specialTime: ProjectSpecialTime): Observable<HttpResponse<void>> {
    if (specialTime.type === PROJECT_SPECIAL_TIME_TYPES.opening)
      return this._httpClient[ "delete" ]<undefined>(`${ buildUrlBase(projectNumber, OPENING_TIMES_URL_SEGMENT) }/${ specialTime.id }`, { observe: "response" });

    return this._httpClient[ "delete" ]<undefined>(`${ buildUrlBase(projectNumber, CLOSING_TIMES_URL_SEGMENT) }/${ specialTime.id }`, { observe: "response" });
  }

  public create (projectNumber: string, specialTime: ProjectSpecialTimeWithoutId): Observable<HttpResponse<void>> {
    return this._httpClient.post<undefined>(buildUrlBase(projectNumber, MERGED_TIMES_URL_SEGMENT), parseToProjectSpecialTimeDto(specialTime), { observe: "response" });
  }
}
